// Components
import { ActionItem } from '@/components/pages/home/keyActions/actionItem';

// Hooks
import { useKeyActions } from '@/utils/hooks/homeKeyActions/useKeyActions';

export const HomeKeyActions = () => {
    const actionsCatalog = useKeyActions();
    return (
        <div className="mt-8 grid w-full grid-cols-4 gap-5 xs:grid-cols-2 lg:grid-cols-4">
            {actionsCatalog.map((action) => (
                <ActionItem key={action.type} action={action} />
            ))}
        </div>
    );
};
